export default __webpack_public_path__ + "static/articles-lutein-virusi-e1a215743f0308d9e76458a9d8fb4256.jpg";